import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

const MetricItem = ({
  chartMetric,
  onSelect,
  active
}: {
  chartMetric:
    | 'RETURN_RATE_CHART_METRIC_UNSPECIFIED'
    | 'RETURN_RATE_CHART_METRIC_QUANTITY'
    | 'RETURN_RATE_CHART_METRIC_AMOUNT'
  onSelect: (
    chartMetric:
      | 'RETURN_RATE_CHART_METRIC_UNSPECIFIED'
      | 'RETURN_RATE_CHART_METRIC_QUANTITY'
      | 'RETURN_RATE_CHART_METRIC_AMOUNT'
  ) => void
  active: boolean
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        'flex cursor-pointer items-center rounded-md px-3 py-1 text-sm font-medium leading-tight',
        {
          'bg-white shadow-md text-[#0d111b]': active,
          'text-[#99a0ad]': !active
        }
      )}
      onClick={() => onSelect(chartMetric)}
    >
      <span>{t(`returns_analytics.chart_metrics.${chartMetric}`)}</span>
    </div>
  )
}

const chartMetrics = [
  'RETURN_RATE_CHART_METRIC_QUANTITY',
  'RETURN_RATE_CHART_METRIC_AMOUNT'
] as const

export const ChartMetricTabs = ({
  selected,
  setSelected
}: {
  selected: string
  setSelected: (
    chartMetric:
      | 'RETURN_RATE_CHART_METRIC_UNSPECIFIED'
      | 'RETURN_RATE_CHART_METRIC_QUANTITY'
      | 'RETURN_RATE_CHART_METRIC_AMOUNT'
  ) => void
}) => {
  return (
    <div className="flex items-center rounded-md bg-neutral-200/70 p-1">
      {chartMetrics.map((chartMetric) => (
        <MetricItem
          key={chartMetric}
          chartMetric={chartMetric}
          onSelect={setSelected}
          active={selected === chartMetric}
        />
      ))}
    </div>
  )
}
